<ion-row *ngIf="paginationStatus !== 'LIMIT_REACHED'" class="ion-justify-content-center">
  <ion-col size="auto">
    <div *ngIf="paginationStatus !== 'FETCHING'" class="view-more-button">
      <ion-button fill="outline" size="medium" (click)="clickEv.emit()">
        {{ 'ACTIONS.SEE_MORE' | translate  }}
      </ion-button>
    </div>
    <div *ngIf="paginationStatus === 'FETCHING'">
      <ion-spinner color="primary" name="bubbles"></ion-spinner>
    </div>
  </ion-col>
</ion-row>